import declarationGeneration from './view/declarationGeneration.html'

export default {
  base: {
    state: 'declaration.vatDeclarationSurcharges.declarationGeneration',
    config: {
      url: '/declarationGeneration',
      abstract: true,
      template: '<div ui-view></div>',
      default:
        'declaration.vatDeclarationSurcharges.declarationGeneration.list',
      title: '申报表生成',
    },
  },
  list: {
    state: 'declaration.vatDeclarationSurcharges.declarationGeneration.list',
    config: {
      url: '/list',
      template: declarationGeneration,
      controller: 'declarationGenerationCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/declarationGeneration/routers.js